import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import { useNavigate } from 'react-router-dom'; // Ensure you're using react-router-dom for navigation
import SEO from '../components/SEO';


const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: '',
    });

    const [status, setStatus] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false); // State to manage button text
    const navigate = useNavigate(); // To navigate to the thank you page

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsSubmitting(true); // Set to true to show "Processing..." on button

        emailjs
            .send(
                'service_1nktqrk', // Replace with your EmailJS service ID
                'template_kkktiwj', // Replace with your EmailJS template ID
                {
                    name: formData.name,
                    email: formData.email,
                    phone: formData.phone,
                    message: formData.message,
                },
                'FdSRX__UgVs90SMPn' // Replace with your EmailJS user ID
            )
            .then(
                () => {
                    setStatus('Message sent successfully!');
                    setFormData({
                        name: '',
                        email: '',
                        phone: '',
                        message: '',
                    });
                    setIsSubmitting(false); // Reset button state
                    setTimeout(() => {
                        navigate('/thank-you'); // Redirect to thank you page
                    }, 1000); // Delay navigation for better UX
                },
                () => {
                    setStatus('Failed to send the message. Please try again.');
                    setIsSubmitting(false); // Reset button state
                }
            );
    };

    return (
        <div className=' bg-white'>
            <SEO
                title="Contact IES Gear | Custom Boxing Equipment Supplier"
                description="Contact IES Gear for custom boxing gloves, MMA gear, private label fight equipment, and wholesale sportswear inquiries."
                keywords="contact boxing gloves supplier, custom boxing equipment inquiry, MMA gear manufacturer contact"
                url="https://iesgear.com/contact"
            />

     
        <div className='max-w-screen-xl mx-auto pt-[120px]'>
            
       
        <div className="flex flex-col items-center px-4 py-8 text-black">
             
            <h1 className="text-3xl font-bold text-center mb-6 ">Contact Us</h1>
            <div className="mb-6">
                <div className="flex items-center justify-center space-x-2">
                    <div className="flex justify-center items-center">
                        <img
                            src="/logo/logo.png"
                            alt="IES Logo"
                            className="h-auto w-36"
                        />
                    </div>
                    <div>
                        <h2 className="font-semibold  text-xl">
                            <span className="text-black">IES</span>
                            <span className=""> </span>
                            <span className="text-[#FF0000] font-orbitron">Gear</span>
                        </h2>
                        <p>
                            Email:{' '}
                            <a
                                href="mailto:infiniteexportsolutions@gmail.com"
                                className="text-black font-semibold"
                            >
                                infiniteexportsolutions@gmail.com
                            </a>
                        </p>
                        <p>
                            Phone:{' '}
                            <a
                                href="tel:+971557711247"
                                className="text-black font-semibold"
                            >
                                +971 5577 11247
                            </a>
                        </p>
                    </div>
                </div>
            </div>

            <h2 className="text-2xl font-bold mb-4">Send an Inquiry</h2>
            <form
                onSubmit={handleSubmit}
                className="w-full bg-white  shadow-md rounded-lg p-6"
            >
                <div className="mb-4">
                    <label className="block text-black font-medium mb-1">
                        Name
                    </label>
                    <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#FF0000]"
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-black font-medium mb-1">
                        Email
                    </label>
                    <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#FF0000]"
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-black font-medium mb-1">
                        Phone
                    </label>
                    <input
                        type="text"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#FF0000]"
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-black font-medium mb-1">
                        Message
                    </label>
                    <textarea
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#FF0000]"
                        rows="4"
                    ></textarea>
                </div>
                <button
                    type="submit"
                    className="w-full bg-black text-white font-bold border-2 border-black py-2 px-4 rounded-md hover:bg-white hover:text-black duration-200 focus:outline-none focus:ring-2 focus:ring-blue-300"
                    disabled={isSubmitting}
                >
                    {isSubmitting ? 'Processing...' : 'Send Message'}
                </button>
            </form>
            {status && (
                <p
                    className={`mt-4 text-center ${
                        status.includes('successfully')
                            ? 'text-green-500'
                            : 'text-red-500'
                    }`}
                >
                    {status}
                </p>
            )}
        </div>
        </div>
        
        </div>
    );
};

export default Contact;
